import { Module } from 'framework/core';

import { PlatformLoader } from './platform.loader';

@Module({
  providers: [PlatformLoader],
  exports: [PlatformLoader],
})
export class PlatformModule {}
